export default __webpack_public_path__ + "static/media/villa_3.573ed0e2.jpg";